import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/user.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: 'app-basic',
  templateUrl: './basic.component.html',
  styleUrls: ['./basic.component.css']
})
export class BasicComponent implements OnInit {

  public email:any;
  public mobile:any;
  public first_name:any;
  public last_name:any;

  public data:any=[];
  ID: any;
  updatedYear: any;
  public details: any;
  ramki: any;
  detailsNew: any;
  constructor(public usr: UserService,
              public toastr: ToastrService,
              private SpinnerService: NgxSpinnerService) 
              {
               let b = JSON.parse(localStorage.getItem('data'));
               this.ramki=b;
  }

  ngOnInit(): void {
    this.usr.getYears().subscribe((res:any)=>
    {
      this.data = res.data;
      // console.log(this.data);
      this.ID = JSON.parse(localStorage.getItem('data'));
      this.updatedYear = JSON.parse(localStorage.getItem('newYear'));
      // console.log(this.updatedYear); 
      
      this.updatedYear = JSON.parse(localStorage.getItem('years'));
                // console.log(this.updatedYear);
    })
   
  }

  onOptionsSelected(value:string)
  {
    // console.log(value);
    let obj = {
      'user_id':this.ID,
      'year':this.updatedYear
    }
    
    this.usr.years(obj).subscribe((res:any)=>
    {
      if(res.code===200)
      {
        this.toastr.success("Basic");
      }
      else{
        this.toastr.error("Error");
      }
    })
  }
}
